export default __webpack_public_path__ + "static/media/contact.719b2b4d.jpg";